import { Box } from '@mui/material';

const EquipoAddPlayerBox = () => {
    return (
        <Box
            sx={{
                width: '100%',
                height: '20px',
                minHeight: '20px',
                background: '#eacfcf85',
                width: '60px',
                borderRadius: '4px',
                justifyContent: 'center',
                display: 'flex',
            }}
            mt={0.5}
        >
            +
        </Box>
    );
};

export default EquipoAddPlayerBox;
